
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"205","height":"70","viewBox":"0 0 54.24 18.521"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('path',{attrs:{"id":"a","d":"M241 413.691h53.579v17.2H241z"}})]),_c('path',{attrs:{"d":"M.668 16.142c.152-3.787 1.56-7.894 3.632-10.6C6.518 2.647 9.332.981 12.33.788l1.004-.064v10.452h1.303V6.137c0-2.77.03-5.115.066-5.21.058-.151.452-.172 3.31-.172h3.245v10.42h1.52V.756h8.684v10.42l.732.001h.733l.002-.733c0-.403.013-2.747.027-5.21l.025-4.478h6.621v10.42h1.303V.725l1.004.064c3.824.246 7.353 2.905 9.494 7.151 1.336 2.65 2.054 5.367 2.168 8.203l.067 1.655h-5.541l-.068-.339a3.78 3.78 0 01-.068-.603c0-.164-.498-.962-1.313-2.103l-1.314-1.84H8.905l-1.313 1.84c-.815 1.14-1.313 1.939-1.313 2.103 0 .145-.03.417-.068.603l-.068.34H.602z","fill":"#f0f0f0"}})])
          )
        }
      }
    